module.exports = __webpack_public_path__ + "static/media/cajasdecontrolFE.3253312b.pdf";